import LoveMatchImage from "@/assets/img/modal/love_match_results.webp"
import { TRUTHS_REPORT_MODAL_V2_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV2, type ReportPromoCopyV2 } from "./report-promo-modal-v2"

const COPY: ReportPromoCopyV2 = {
  reportId: ReportIds.LoveMatch,
  planId: TRUTHS_REPORT_MODAL_V2_PLAN_ID,
  title: "Get Love Match Report",
  description:
    "Reveal hidden signals in your connection, from chemistry and trust to doubts, patterns, and warning signs",
  image: LoveMatchImage,
}

export function ReportLoveMatchModalV2(props: AppModalComponentProps) {
  return <ReportPromoModalV2 {...props} copy={COPY} />
}
